import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteProvider } from "./context/SiteContext";

// Golf Site Pages
import GolfHomePage from "./pages/golf/GolfHomePage";
import GolfAboutPage from "./pages/golf/GolfAboutPage";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<GolfHomePage />} />
            <Route path="/a-propos" element={<GolfAboutPage />} />
            <Route path="*" element={<GolfHomePage />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
    </div>
  );
}

export default App;
